function getCobrand() {
	var cobrands = JSON.parse(localStorage.getItem("userData")).cobrands;
	var cobrandId = localStorage.getItem("cobrandId");
	var index = cobrands.findIndex(function(cobrand, i) {
		return cobrand.id.toString() === cobrandId;
	});
	return index > -1 ? cobrands[index] : cobrands[0];
}

export default getCobrand;